<footer class="footer-area">
    <div class="container-fluid mb-4">
        <div class="row">
            <div class="col-lg-3 col-md-4 pt-5">
                <h3 class="text-center text-white">Pages</h3>
                <div class="footer-list d-flex">
                    <ul>
                        <li><a class="text-white" routerLink="/mainMenu">Main Menu</a></li>
                        <li><a class="text-white" routerLink="/mainMenu">Lunch Menu</a></li>
                        <li><a class="text-white" routerLink="/menu/maincategory/2/catering">Catering Menu</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-8">
                <div class="row mx-4">
                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
                        <a routerLink="/"><img src="assets/img/logo.png" width="164" alt="Logo"></a>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 workingHours">
                        <div class="row mx-4">
                            <div class="col-md-12">
                                <span class="openingHoursTitle">Opening Hours</span>
                            </div>
                            <div class="col-md-12">
                                <p class="openingHours">"{{working_hours || ''}}"</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 pt-5">
                <div class="footer-side-list">
                    <ul>
                        <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                        <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                        <li><i class='bx bxs-map'></i> <a href="https://share.google/v3m9EIZuQcQe2InEk" target="_blank">{{address}}</a></li>
                    </ul>
                </div>
                <div class="socialMedia">
                    <h5 class="text-white">Follow Us</h5>
                    <ul class="social-list">
                        <li class="social-icon"><a href="https://www.facebook.com/profile.php?id=61580630124845" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                        <li class="social-icon"><a href="https://www.instagram.com/roma_pizza_nj/" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        <li class="social-icon"><a href="https://www.tiktok.com/@roma_pizza_nj" target="_blank"><i class="bx bxl-tiktok"></i></a></li>
                        <!-- <li class="social-icon"><a href="https://twitter.com/onepicedigitalsolutions" target="_blank"><i class="bx bxl-twitter"></i></a></li> -->
                    </ul>
                </div>
            </div>
        </div>


        <!-- <div class="row mx-4">
            <div class="col-lg-3 col-md-4 col-sm-12">
                <a routerLink="/"><img src="assets/img/logo.png" width="164" alt="Logo"></a>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 workingHours">
                <div class="row mx-4">
                    <div class="col-md-5">
                        <span class="openingHoursTitle">Opening Hours</span>
                    </div>
                    <div class="col-md-7">
                        <p class="openingHours">"{{working_hours || ''}}"</p>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <div class="pt-4">
            <div class="row mx-4" style="border-bottom: 1px solid #000;">
                <div class="col-lg-3 col-md-6">
                    <p style="color: #fff;">Lorem ipsum dolor sit amet, consectetur adipiscing elitsed do eiusmod tempor incididunt ut labore </p>
                    <div class="socialMedia">
                        <h5 class="text-white">Follow Us</h5>
                        <ul class="social-list">
                            <li class="social-icon"><a href="https://www.facebook.com/onepicedigitalsolutions/" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li class="social-icon"><a href="https://www.instagram.com/onepicedigitalsolutions/" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                            <li class="social-icon"><a href="https://www.linkedin.com/company/one-pice-digital-solutions/" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li class="social-icon"><a href="https://twitter.com/onepicedigitalsolutions" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="footer-list d-flex">
                        <ul>
                            <li><a class="text-white" routerLink="/menu/maincategory/2/catering">Main Menu</a></li>
                            <li><a class="text-white" routerLink="/menu/maincategory/1/lunch">Lunch Menu</a></li>
                            <li><a class="text-white" routerLink="/menu">Catering Menu</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="footer-list d-flex">
                        <ul>
                            <li><a class="text-white" routerLink="/terms-condition">Terms</a></li>
                            <li><a class="text-white" routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li><a class="text-white" routerLink="/order-apps">Order Apps</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-side-list">
                        <ul>
                            <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                            <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                            <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/6xRRnn1AUrBJtjvf7" target="_blank">{{address}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
    </div>

    <div class="footer-bottom">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6">
                    <div class="bottom-text d-block">
                        <p class="pb-0">© 2025 Roma Pizza . All rights reserved</p>
                        <p class="pt-1">Website Designed & Developed By <a href="http://onepice.org/" target="_blank">ONE PICE DIGITAL SOLUTIONS</a></p>
                    </div>
                </div>
                <div class="col-lg-6 d-flex justify-content-center align-items-center">
                    <div class="footer-list mb-0">
                        <p class="mb-0"><a class="text-white" routerLink="/privacy-policy">Privacy Policy</a> / <a class="text-white" routerLink="/terms-condition">Terms</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>